import React from "react";
import {Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton} from "@mui/material";
import {DialogProps} from "./types.ts";
import CloseIcon from '@mui/icons-material/Close';

const Dialogs = (props: DialogProps) => {
    const {
        open,
        onSubmit,
        title,
        contentText,
        children,
        actionButtons = undefined,
        handleClose,
        noCloseIcon = false
    } = props;

    return <Dialog
        fullWidth
        maxWidth="sm"
        open={open.open}
        onClose={handleClose}
    >
        {title && <DialogTitle>{title}</DialogTitle>}
        {!noCloseIcon && <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
            }}
        >
            <CloseIcon />
        </IconButton>}
        <DialogContent>
            {contentText && <DialogContentText>{contentText}</DialogContentText>}
            {children}
        </DialogContent>
        {!!actionButtons && <DialogActions sx={{mb: 1, mt: 2}}>
            {actionButtons}
        </DialogActions>}
    </Dialog>

}

export default Dialogs;